const OrderDetails = ({ data }) => {
  const headerTexet = ["#", "التعيين", "العدد"];
  console.log("OrderDetails ", data);
  return (
    <table className="table">
      <thead className="table-light">
        <tr>
          {headerTexet.map((text, idx) => (
            <th scope="col" key={"order-details" + idx}>
              {text}
            </th>
          ))}
        </tr>
      </thead>
      <tbody class="table-group-divider">
        {data.map((obj, idx) => {
          return (
            <tr key={"order-details-tr" + idx}>
              <td>{idx + 1}</td>
              <td>{obj.item_name}</td>
              <td>{obj.ordered_quantity}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
export default OrderDetails;
